import React, { useContext } from 'react';
import { SMFooterContext } from '../SMFooterContext';

import './copy-right.scss';

const CopyRight = () => {
  const { isPrivateLabel } = useContext(SMFooterContext);
  const year = new Date().getFullYear();
  if (isPrivateLabel) {
    return (
      <span className="sm-copy-right">{`Copyright © ${year} Momentive`}</span>
    );
  }
  return (
    <span className="sm-copy-right">{`Copyright © 1999-${year} SurveyMonkey`}</span>
  );
};

export default CopyRight;
